import React, { useState, useEffect } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import BackButton from "../CommonComponents/BackButton";
import Loader from "../../Loader";
import axios from "axios";

const GET_SERVICES = gql`
  query {
    getAdminService {
      services {
        id
        name
      }
    }
  }
`;

const ADD_BANNER = gql`
  mutation addBanner($data: bannerInput) {
    addBanner(data: $data) {
      status
      message
    }
  }
`;

const UPDATE_BANNER = gql`
  mutation updateBanner($data: UpdateBannerInput!) {
    updateBanner(data: $data) {
      status
      message
    }
  }
`;

const BannerModal = ({ setShowModal, initialData = null }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [gender, setGender] = useState("Male");
  const [isRefer, setIsRefer] = useState(false);
  const [isPromotional, setIsPromotional] = useState(false);
  const [isFeatured, setIsFeatured] = useState(false);
  const [uploading, setUploading] = useState(false);

  const { data: servicesData } = useQuery(GET_SERVICES);
  const services = servicesData?.getAdminService?.services || [];

  const [addBanner, { loading: addLoading }] = useMutation(ADD_BANNER);
  const [updateBanner, { loading: updateLoading }] = useMutation(UPDATE_BANNER);

  const [serviceId, setServiceId] = useState("");
  const [showAddToCart, setShowAddToCart] = useState(false);
  const [isFirstTimeUserOnly, setIsFirstTimeUserOnly] = useState(false);
  const [userIds, setUserIds] = useState("");

  useEffect(() => {
    if (initialData) {
      setPreview(`https://api.barbera.in${initialData.image}`);
      setGender(initialData.gender || "Male");
      setIsRefer(initialData.isRefer || false);
      setIsPromotional(initialData.isPromotional || false);
      setIsFeatured(initialData.isFeatured || false);
      setServiceId(initialData.serviceId || "");
      setShowAddToCart(initialData.showAddToCart || false);
      setIsFirstTimeUserOnly(initialData.isFirstTimeUserOnly || false);
      setUserIds(initialData.userIds ? initialData.userIds.join(", ") : "");
    }
  }, [initialData]);

  // Ensure only one option can be true
  // Ensure only one option can be true, or none
  const handleOptionChange = (option) => {
    setIsRefer(option === "refer");
    setIsPromotional(option === "promotional");
    setIsFeatured(option === "featured");
    if (option === "none") {
      setIsRefer(false);
      setIsPromotional(false);
      setIsFeatured(false);
    }
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      setPreview(URL.createObjectURL(selected));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file && !initialData) {
      alert("Please select an image");
      return;
    }
    // if (!isRefer && !isPromotional && !isFeatured) {
    //   alert("Please select one banner option");
    //   return;
    // }

    let uploadedImagePath = initialData?.image || "";
    if (file) {
      try {
        setUploading(true);
        // Replace this with your actual upload API
        const formData = new FormData();
        formData.append("file", file);
        const url = `https://api.barbera.in/img/upload`;

        // const res = await fetch("https://api.barbera.in/img/upload", {
        //   method: "POST",
        //   body: formData,
        // });

        const { data } = await axios.post(url, formData);
        if (data.success === true) {
          console.log("Upload done");
          uploadedImagePath = data.url; // backend should return image path
        } else {
          throw new Error("Upload failed");
        }
      } catch (err) {
        console.error("File upload failed:", err);
        setUploading(false);
        return;
      } finally {
        setUploading(false);
      }
    }

    const payload = {
      image: uploadedImagePath,
      gender,
      isRefer,
      isPromotional,
      isFeatured,
      serviceId: serviceId || null,
      showAddToCart,
      isFirstTimeUserOnly,
      userIds: userIds ? userIds.split(",").map(id => id.trim()).filter(id => id) : null,
    };

    console.log(payload);

    try {
      if (initialData) {
        const res = await updateBanner({
          variables: { data: { id: initialData.id, ...payload } },
        });
        if (res.data.updateBanner.status === "SUCCESS") {
          window.location.reload();
        } else {
          alert(res.data.updateBanner.message || "Failed to update banner");
        }
      } else {
        const res = await addBanner({ variables: { data: payload } });
        if (res.data.addBanner.status === "SUCCESS") {
          window.location.reload();
        } else {
          alert(res.data.addBanner.message || "Failed to add banner");
        }
      }
    } catch (err) {
      console.error("Error saving banner:", err);
    }
  };

  if (addLoading || updateLoading || uploading) return <Loader />;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-[#202125] rounded-lg p-6 w-[90%] md:w-[500px]">
        <BackButton onClick={() => setShowModal(false)} />

        <h3 className="text-[#FBB033] font-bold text-xl mb-4">
          {initialData ? "Edit Banner" : "Upload New Banner"}
        </h3>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* File Upload */}
          <div>
            <label className="block text-sm text-gray-300 mb-1">
              Banner Image
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="text-white"
            />
            {preview && (
              <img
                src={preview}
                alt="Preview"
                className="mt-2 w-full max-h-40 object-cover rounded"
              />
            )}
          </div>

          {/* Gender Select */}
          <div>
            <label className="block text-sm text-gray-300 mb-1">Gender</label>
            <select
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              className="w-full px-3 py-2 rounded bg-[#0c0b0b] text-white border border-gray-600"
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>

          {/* Exclusive Boolean Options */}
          <div>
            <label className="block text-sm text-gray-300 mb-2">
              Banner Options
            </label>
            <div className="flex flex-col gap-2 text-white text-sm">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="bannerOption"
                  checked={isRefer}
                  onChange={() => handleOptionChange("refer")}
                />
                Is Refer
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="bannerOption"
                  checked={isPromotional}
                  onChange={() => handleOptionChange("promotional")}
                />
                Is Promotional
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="bannerOption"
                  checked={isFeatured}
                  onChange={() => handleOptionChange("featured")}
                />
                Is Featured
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="bannerOption"
                  checked={!isRefer && !isPromotional && !isFeatured}
                  onChange={() => handleOptionChange("none")}
                />
                None
              </label>
            </div>
          </div>

          {/* Mapped Service */}
          <div>
            <label className="block text-sm text-gray-300 mb-1">Mapped Service</label>
            <select
              value={serviceId}
              onChange={(e) => setServiceId(e.target.value)}
              className="w-full px-3 py-2 rounded bg-[#0c0b0b] text-white border border-gray-600"
            >
              <option value="">None (No service mapped)</option>
              {services.map((srv) => (
                <option key={srv.id} value={srv.id}>
                  {srv.name}
                </option>
              ))}
            </select>
          </div>

          {/* First Time User Only */}
          <div className="flex items-center gap-2 text-white text-sm">
            <input
              type="checkbox"
              id="isFirstTimeUserOnly"
              checked={isFirstTimeUserOnly}
              onChange={(e) => setIsFirstTimeUserOnly(e.target.checked)}
            />
            <label htmlFor="isFirstTimeUserOnly">First Time User Only</label>
          </div>

          {/* Show Add To Cart */}
          <div className="flex items-center gap-2 text-white text-sm">
            <input
              type="checkbox"
              id="showAddToCart"
              checked={showAddToCart}
              onChange={(e) => setShowAddToCart(e.target.checked)}
            />
            <label htmlFor="showAddToCart">Show Add To Cart Button</label>
          </div>

          {/* Targeted User IDs */}
          <div>
            <label className="block text-sm text-gray-300 mb-1">
              Targeted User IDs (Comma separated, optional)
            </label>
            <textarea
              value={userIds}
              onChange={(e) => setUserIds(e.target.value)}
              placeholder="e.g. user_id_1, user_id_2"
              className="w-full px-3 py-2 rounded bg-[#0c0b0b] text-white border border-gray-600 h-20 outline-none"
            />
          </div>

          {/* Submit Button */}
          <div className="flex justify-center pt-4">
            <button
              type="submit"
              disabled={!file && !initialData}
              className={`py-2 px-6 rounded-md font-bold ${
                !file && !initialData
                  ? "bg-gray-500 cursor-not-allowed"
                  : "bg-[#FBB034] text-[#202125]"
              }`}
            >
              {initialData ? "Update Banner" : "Upload Banner"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BannerModal;
